var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.999 8.9a.625.625 0 0 0-.625.625v8.911a.625.625 0 1 0 1.25 0V9.526a.625.625 0 0 0-.625-.625M7.374 9.525a.625.625 0 0 1 1.25 0v8.911a.625.625 0 1 1-1.25 0zM15.999 8.9a.625.625 0 0 0-.625.625v8.911a.625.625 0 1 0 1.25 0V9.526a.625.625 0 0 0-.625-.625"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2364A",
  fillRule: "evenodd",
  d: "M9.5 1.373A3.127 3.127 0 0 0 6.373 4.5v1.373H2.5v1.254H4v11.85C4 20.648 5.343 22 7 22h10c1.657 0 3-1.353 3-3.022V7.127h1.5V5.873h-3.873V4.5c0-1.727-1.4-3.127-3.127-3.127zm6.873 4.5H7.627V4.5c0-1.034.839-1.873 1.873-1.873h5c1.034 0 1.873.839 1.873 1.873zM5.25 18.979V7.14h13.5v11.838c0 .973-.784 1.763-1.75 1.763H7c-.966 0-1.75-.79-1.75-1.764",
  clipRule: "evenodd"
})));
export { SvgIconTrash as ReactComponent };